var render = function (_h,_vm) {var _c=_vm._c;return _c('a',_vm._g(_vm._b({class:['GigyaMenuItem', _vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"href":_vm.props.dataGigyaProfileUrl}},'a',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }